import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ComplaintNotesVisibility, ComplaintNotesVisibilityColors, ComplaintNoteVisibility } from '@icc/b2b/shared';

@Component({
    selector: 'icc-complaint-note-visibility',
    templateUrl: './complaint-note-visibility.component.html',
    styles: [':host { display: inline-block; }'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplaintNoteVisibilityComponent {
    private _visibility: ComplaintNoteVisibility;

    @Input()
    get visibility(): ComplaintNoteVisibility {
        return this._visibility;
    }
    set visibility(value: ComplaintNoteVisibility) {
        this._visibility = value;
        this.colorRgbHex = ComplaintNotesVisibilityColors[value];
        this.name = ComplaintNotesVisibility[value];
    }

    colorRgbHex = '';
    name = '';
}
